module.exports = __webpack_public_path__ + "img/this-month-theme.8f3123eb.png";